function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
import { configure } from "mobx";
import { RouterStore } from "@superwf/mobx-react-router";
import AjaxService from "@/services/ajax-service";

// import UserInfoStore from "./user-store"
import HomeStore from "./home-store";
// import LoginStore from "./login-store"
import UiStore from "./ui-store";
import FaqStore from "@/stores/faq-store";
import NewsStore from "@/stores/news-store";
configure({
  useProxies: "never",
  enforceActions: "never"
});
var RootStore = /*#__PURE__*/_createClass(function RootStore(onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse) {
  _classCallCheck(this, RootStore);
  _defineProperty(this, "service", void 0);
  _defineProperty(this, "routingStore", void 0);
  _defineProperty(this, "uiStore", void 0);
  _defineProperty(this, "faqStore", void 0);
  _defineProperty(this, "newsStore", void 0);
  // userInfoStore: UserInfoStore;
  // loginStore: LoginStore;
  _defineProperty(this, "homeStore", void 0);
  this.uiStore = new UiStore();
  this.service = new AjaxService(this.uiStore, onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse);
  // this.userInfoStore = new UserInfoStore(this);
  // this.loginStore = new LoginStore(this);
  this.homeStore = new HomeStore(this);
  this.routingStore = new RouterStore();
  this.faqStore = new FaqStore(this);
  this.newsStore = new NewsStore(this);
});
export default RootStore;